import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { QueryParamProvider } from 'use-query-params';
import CustomReactRouter7Adapter from '../../src/utilities/custom_react_router_7_adapter';

import { JobSearchContextProvider } from '../../src/job_search/context';
import JobSearch from '../../src/job_search/job_search';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';
import { addBackToTop, DEFAULT_SETTINGS } from '../../src/components/back_to_top/back_to_top';

document.addEventListener('DOMContentLoaded', () => {
  addBackToTop(DEFAULT_SETTINGS);

  const container = document.getElementById('jobSearchReactApp');
  if (!container) return;

  const root = createRoot(container);

  // Prevent the page from scrolling down to where it was previously
  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  }

  root.render(
    <DevexHighOrderComponent>
      <BrowserRouter>
        <QueryParamProvider adapter={CustomReactRouter7Adapter}>
          <JobSearchContextProvider
            deviceInfo={JSON.parse(container.dataset.deviceInfo)}
            careerLevels={JSON.parse(container.dataset.careerLevels)}
            contractLengths={JSON.parse(container.dataset.contractLengths)}
            dataGatheringBannerField={JSON.parse(container.dataset.dataGatheringBannerField) || ''}
            landingPageInfo={JSON.parse(container.dataset.landingPageInfo)}
            adbutlerInfo={JSON.parse(container.dataset.adbutlerInfo)}
          >
            <JobSearch />
          </JobSearchContextProvider>
        </QueryParamProvider>
      </BrowserRouter>
    </DevexHighOrderComponent>
  );
});
